module.exports = __webpack_public_path__ + "static/img/2.e8a7397.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-construccion/2.png
// module id = EI1j
// module chunks = 0